import { onMounted } from "vue";
import { useStore } from "vuex";
import { useHreflang } from "@/composables/useHreflang";

export default {
	name: "App",
	components: {},
	setup() {
		const store = useStore();
		const { initializeHreflang } = useHreflang();

		onMounted(async () => {
			// Initialize languages first
			await store.dispatch("languages/setLanguages");

			// Then initialize hreflang functionality
			initializeHreflang();
		});

		return {};
	},
};
